import React, { useEffect, useState } from 'react';
import { getAllStickies } from '../../../../Core/Services/InternalUser/ControllerService/noteService';

import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import './NotesandSticky.scss';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(1)
        }
    }
}));

export const StickyNotes = (props) => {
    const classes = useStyles();
    const [state, setState] = useState({
        stickyList: []
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getAllStickies(
                    props.frompage,
                    props.NoteVehicleID,
                    props.NoteServiceAgID,
                    props.customerID,
                    props.NoteDriverID,
                    props.noteRefsGuidID
                );
                setState((st) => ({ ...st, stickyList: res.data }));
            } catch (error) {
                console.error('Error fetching stickies:', error);
            }
        };

        if (props.NoteVehicleID) {
            fetchData();
        }
    }, [props.NoteVehicleID]);

    return (
        <>
            {state.stickyList.length > 0 && (
                <div className="alert-container">
                    {state.stickyList.map((q, index) => (
                        <Alert key={index} severity="warning" className="alert-items">
                            {q.title}
                            <br />
                            {q.description}
                        </Alert>
                    ))}
                </div>
            )}
        </>
    );
};

export default StickyNotes;
